import { Box, Button, HStack, Icon, Menu, Portal, Stack, Text } from '@chakra-ui/react';
import { LuChevronDown, LuMapPin } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { useProject } from '@/lib/ProjectContext';
import { useMe } from '@/lib/MeContext';

export function ProjectSelector() {
  const { projects, activeProject, setActiveProject, loading } = useProject();
  const { me } = useMe();
  const navigate = useNavigate();

  if (loading) return null;

  if (projects.length === 0) {
    if (me?.role !== 'admin') {
      return (
        <Text fontSize="sm" color="fg.muted">
          Sin proyectos
        </Text>
      );
    }
    return (
      <Button size="sm" variant="outline" onClick={() => navigate('/proyectos/nuevo')}>
        <Icon as={LuMapPin} />
        <Text display={{ base: 'none', sm: 'inline' }}>Crear primer proyecto</Text>
        <Text display={{ base: 'inline', sm: 'none' }}>Crear</Text>
      </Button>
    );
  }

  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <Button size="sm" variant="ghost" px="2" maxW={{ base: '180px', md: 'none' }}>
          <HStack gap="2.5" align="center" minW={0}>
            <Icon as={LuMapPin} color="brand.500" flexShrink={0} />
            {/* Mobile: code only */}
            <Text
              display={{ base: 'inline', md: 'none' }}
              fontSize="sm"
              fontWeight="700"
              lineHeight="1.1"
              truncate
            >
              {activeProject?.code ?? 'Seleccionar'}
            </Text>
            {/* Desktop: label + name */}
            <Stack gap="0" align="start" display={{ base: 'none', md: 'flex' }}>
              <Text fontSize="2xs" color="fg.muted" lineHeight="1">
                Proyecto
              </Text>
              <Text fontSize="sm" fontWeight="700" lineHeight="1.1">
                {activeProject?.name ?? 'Seleccionar'}
              </Text>
            </Stack>
            <Icon as={LuChevronDown} color="fg.muted" flexShrink={0} />
          </HStack>
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content minW="280px">
            <Menu.ItemGroup>
              <Menu.ItemGroupLabel>Proyectos activos</Menu.ItemGroupLabel>
              {projects.map((p) => (
                <Menu.Item
                  key={p.id}
                  value={p.id}
                  onClick={() => setActiveProject(p.id)}
                  fontWeight={p.id === activeProject?.id ? '600' : '500'}
                >
                  <Stack gap="0">
                    <Text>{p.name}</Text>
                    <Text fontSize="xs" color="fg.muted">
                      {p.code}
                      {p.municipalityName ? ` · ${p.municipalityName}` : ''}
                      {p.departmentName && !p.municipalityName ? ` · ${p.departmentName}` : ''}
                    </Text>
                  </Stack>
                </Menu.Item>
              ))}
            </Menu.ItemGroup>
            {me?.role === 'admin' && (
              <>
                <Menu.Separator />
                <Menu.Item value="manage" onClick={() => navigate('/proyectos')}>
                  <Box>
                    <Text fontSize="sm" fontWeight="600">
                      Administrar proyectos
                    </Text>
                    <Text fontSize="xs" color="fg.muted">
                      Crear, editar o archivar
                    </Text>
                  </Box>
                </Menu.Item>
              </>
            )}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
}
